module.exports = "<div data-component=\"summary\" class=\"step\" *ngIf=\"active\">\n\t<app-warning [message]=\"changePassData.message\" [type]=\"changePassData.success ? 'success' : 'error'\"></app-warning>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/change-pass/summary/summary.component.html
// module id = ../../../../../src/app/master/change-pass/summary/summary.component.html
// module chunks = main